import { MesfModal } from "@dexteel/mesf-core";
import { Button, Grid2, Typography } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
	title?: string;
	subject?: string;
	message: string;
	show: boolean;
	confirmColor?: "primary" | "secondary";
	onHide: (proceed: boolean) => void;
	children?: ReactNode;
};

export const ConfirmMessageModal = ({
	title = "CONFIRM",
	subject,
	message,
	show,
	confirmColor = "primary",
	onHide,
	children,
}: Props) => (
	<MesfModal
		title={title}
		open={show}
		id="confirm-message-modal"
		handleClose={() => onHide(false)}
		maxWidth="sm"
	>
		<MesfModal.Content dividers style={{ padding: "15px 30px" }}>
			{subject && (
				<Typography variant="body1" fontWeight={600} sx={{ mb: 1 }}>
					{subject}
				</Typography>
			)}
			<Typography variant="body1">{message}</Typography>
			{children}
		</MesfModal.Content>
		<MesfModal.Actions style={{ padding: "20px 30px" }}>
			<Grid2 container spacing={2} justifyContent="flex-end">
				<Grid2 size={{ md: 3, xs: 12 }} style={{ margin: 0 }}>
					<Button
						fullWidth
						variant="contained"
						color="inherit"
						onClick={() => onHide(false)}
					>
						No
					</Button>
				</Grid2>
				<Grid2 size={{ md: 3, xs: 12 }} style={{ margin: 0 }}>
					<Button
						fullWidth
						variant="contained"
						color={confirmColor}
						onClick={() => onHide(true)}
					>
						Yes
					</Button>
				</Grid2>
			</Grid2>
		</MesfModal.Actions>
	</MesfModal>
);
